<template>
  <v-card>
    <v-container fluid>
      <v-row no-gutters>
        <v-col>
          <h2 class="title">Órdenes de Servicios Abiertos en Obra</h2>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row no-gutters>
        <v-col align-content="center" cols="6" class="height-chart pt-9">
          <v-row no-gutters>
            <v-col cols="12" class="px-2 body-2">
              {{
                chartOptionsWorkPrevent.series[0].data == 1
                  ? "Preventivo"
                  : "Preventivos"
              }}
            </v-col>
          </v-row>
          <highcharts
            class="barchart"
            :options="chartOptionsWorkPrevent"
          ></highcharts>
          <v-row no-gutters>
            <v-col cols="12" class="px-2 body-2">
              {{
                chartOptionsWorkCorrect.series[0].data == 1
                  ? "Correctivo"
                  : "Correctivos"
              }}
            </v-col>
          </v-row>
          <highcharts
            class="barchart"
            :options="chartOptionsWorkCorrect"
          ></highcharts>
        </v-col>
        <v-col cols="6">
          <v-row no-gutters class="row-height" align="center">
            <v-col class="body-2" cols="12">
              <v-row no-gutters>
                <v-col cols="12" class="pt-3 pl-2 ma-0">Preventivos</v-col>
              </v-row>
              <v-row no-gutters class="py-1 px-2">
                <v-col cols="6">Servicios menor a 1 día.</v-col>
                <v-col cols="6" class="primary--text text-right"
                  >{{ lowerThanOnePreventField }} equipos</v-col
                >
                <v-col cols="6">Servicios mayor a 1 día.</v-col>
                <v-col cols="6" class="red--text text-right"
                  >{{ higherThanOnePreventField }} equipos</v-col
                >
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pt-3 pl-2 ma-0">Correctivos</v-col>
              </v-row>
              <v-row no-gutters class="py-1 px-2">
                <v-col cols="6">Servicios menor a 1 día.</v-col>
                <v-col cols="6" class="primary--text text-right"
                  >{{ lowerThanOneCorrectField }} equipos</v-col
                >
                <v-col cols="6">Servicios mayor a 1 día.</v-col>
                <v-col cols="6" class="red--text text-right"
                  >{{ higherThanOneCorrectField }} equipos</v-col
                >
              </v-row>
              <v-row no-gutters>
                <v-col cols="6" class="py-1 pl-2 subtitle-1">Total</v-col>
                <v-col cols="6" class="text-right py-1 px-2 subtitle-1">
                  {{
                    parseInt(chartOptionsWorkPrevent.series[0].data) +
                      parseInt(chartOptionsWorkCorrect.series[0].data)
                  }}
                  {{ "servicios" }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  mounted() {
    if (this.$route.params.branchOffice) {
      this.getServicesByTypeAndPlace({
        type: "Correctivo",
        place: "Obra",
        branch: this.$route.params.branchOffice
      });
      this.getServicesByTypeAndPlace({
        type: "Preventivo",
        place: "Obra",
        branch: this.$route.params.branchOffice
      });
    } else {
      this.getServicesByTypeAndPlace({
        type: "Correctivo",
        place: "Obra"
      });
      this.getServicesByTypeAndPlace({
        type: "Preventivo",
        place: "Obra"
      });
    }
  },
  updated() {
    if (
      parseInt(this.chartOptionsWorkPrevent.series[0].data) +
        parseInt(this.chartOptionsWorkCorrect.series[0].data) >
      0
    ) {
      this.chartOptionsWorkPrevent.yAxis.max =
        parseInt(this.chartOptionsWorkPrevent.series[0].data) +
        parseInt(this.chartOptionsWorkCorrect.series[0].data);
      this.chartOptionsWorkCorrect.yAxis.max =
        parseInt(this.chartOptionsWorkPrevent.series[0].data) +
        parseInt(this.chartOptionsWorkCorrect.series[0].data);
    } else {
      this.chartOptionsWorkPrevent.yAxis.max = 10;
      this.chartOptionsWorkCorrect.yAxis.max = 10;
    }
  },
  computed: {
    ...mapState("services", [
      "chartOptionsWorkPrevent",
      "chartOptionsWorkCorrect",
      "higherThanOnePreventField",
      "lowerThanOnePreventField",
      "higherThanOneCorrectField",
      "lowerThanOneCorrectField"
    ])
  },
  methods: {
    ...mapActions("services", ["getServicesByTypeAndPlace"])
  },
  watch: {
    "$route.params.branchOffice": {
      handler: function(branch) {
        if (branch) {
          this.getServicesByTypeAndPlace({
            type: "Correctivo",
            place: "Obra",
            branch: branch
          });
          this.getServicesByTypeAndPlace({
            type: "Preventivo",
            place: "Obra",
            branch: branch
          });
        } else {
          this.getServicesByTypeAndPlace({
            type: "Correctivo",
            place: "Obra"
          });
          this.getServicesByTypeAndPlace({
            type: "Preventivo",
            place: "Obra"
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="css">
.barchart .highcharts-container {
  height: 50px !important;
}
</style>
<style lang="css" scoped>
.title {
  font-weight: 400 !important;
  color: black;
  font-size: 16px !important;
}
.headline,
.body-2 {
  font-weight: 300 !important;
  color: #808080;
}
.height-chart {
  height: 200px !important;
}
.row-height {
  height: 100%;
}
</style>
